"use client";

import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import addSpaces from "../helpers/addSpaces";
import { Link, useNavigate } from "react-router-dom";

function FooterNavigation(props) {
  const navigate = useNavigate();
  const [prev, setPrev] = useState("");
  const [next, setNext] = useState("");

  useEffect(() => {
    let formattedText = addSpaces(props.api);
    const current_index = props.data.indexOf(formattedText);
    if (current_index === 0) {
      setPrev("Introduction");
      setNext(props.data[current_index + 1]);
    } else if (current_index > 0) {
      if (current_index + 1 === props.data.length) {
        setPrev(props.data[current_index - 1]);
        setNext("");
      } else {
        setPrev(props.data[current_index - 1]);
        setNext(props.data[current_index + 1]);
      }
    } else {
      setPrev("");
      setNext("");
    }
  }, [props.api]);

  const redirectPrev = () => {
    navigate(
      prev === "Introduction"
        ? "/#intro-purpose"
        : `/${prev.split(" ").join("")}`
    );
  };

  const redirectNext = () => {
    navigate(`/${next.split(" ").join("")}`);
  };

  return (
    <Box className="footer-buttons">
      <Button onClick={redirectPrev} size="large" startIcon={<ArrowBackIcon />}>
        {prev}
      </Button>

      <Button
        sx={{ visibility: next === "" ? "hidden" : "visible" }}
        onClick={redirectNext}
        size="large"
        endIcon={<ArrowForwardIcon />}
      >
        {next}
      </Button>
    </Box>
  );
}

export default FooterNavigation;
